import i18n from 'i18n'
import { BasketError } from 'proto/eshop/Basket_pb'
import { ServiceError } from './ServiceError'
import { grpc } from '@improbable-eng/grpc-web'
import { DiscountError } from './DiscountError'

function getBasketErrorMessage(error: BasketError) {
	let message = i18n.gettext('Unexpected error!')
	const requestCode = error.getRequestId() && i18n.gettext('Request code %s', error.getRequestId())
	switch (error.getCode()) {
		case BasketError.Code.INTERNAL:
			message = i18n.gettext('Internal server error!'); break
		case BasketError.Code.BAD_REQUEST:
			message = i18n.gettext('Invalid request!'); break
		case BasketError.Code.NOT_FOUND:
			message = i18n.gettext('The required article of merchandise is not found!'); break
		case BasketError.Code.PAYMENT_GATEWAY_UNAVAILABLE:
			message = i18n.gettext('The payment system is not responding'); break
	}
	return `${message}\n${requestCode}`
}

function getServiceErrorMessage(error: ServiceError) {
	const errorCode = i18n.gettext('Error code: %s', error.code)
	let message = `${i18n.gettext('Unexpected error!')}\n${error.message}`

	switch (error.code) {
		case grpc.Code.Unavailable:
			message = i18n.gettext('The server is temporarily unavailable.\nPlease try again later.'); break
		case grpc.Code.Unknown:
			message = proxyBuiltInErrorMessage(error)
	}

	return `${errorCode}\n${message}`
}

function proxyBuiltInErrorMessage(error: ServiceError) {
	// NOTE: нужно, чтобы тексты стандартных ошибок grpc попали в pot
	switch (error.message) {
		case 'Response closed without headers':
			return i18n.gettext('Unable to connect to the server.\nPlease check your Internet connection.')
	}
	return error.message
}

export function extractErrorDetails(error: BasketError | ServiceError | Error): { message: string, name: string } {
	const name = i18n.gettext('Error')
	if (error instanceof BasketError) {
		return {
			message: getBasketErrorMessage(error),
			name,
		}
	} else if (error instanceof DiscountError) {
		return {
			message: error.message,
			name: error.title,
		}
	} else if ('code' in error) {
		const serviceError: ServiceError = ServiceError.create(error)
		return {
			message: getServiceErrorMessage(serviceError),
			name,
		}
	} else {
		return {
			message: `${i18n.gettext('An unknown error has occurred!')}\n${error}`,
			name,
		}
	}
}
